import { CVSummaryAction } from '../actions/cvSummary'

const initialState: Props = {
  clientId: 0,
  tableColumns: [],
  tableData: [],
  totalClickReport: 0,
  sum: 0,
  isFetching: false,
}

interface Props {
  clientId: number
  tableColumns: any
  tableData: any
  totalClickReport: number
  sum: number
  isFetching: boolean
}

const reducer = (
  state: Props = initialState,
  action: CVSummaryAction,
): Props => {
  switch (action.type) {
    case 'INIT_CV_SUMMARY': {
      return {
        ...state,
        clientId: action.clientId,
      }
    }
    case 'REQUEST_FETCH_CV_SUMMARY': {
      return {
        ...state,
        isFetching: true,
      }
    }
    case 'COMPLETE_FETCH_CV_SUMMARY': {
      return {
        ...state,
        tableColumns: action.cv.columns,
        tableData: action.cv.cv_lists,
        isFetching: false,
      }
    }
    case 'CLEAR_TABLE_STATE': {
      return {
        ...state,
        tableColumns: [],
        tableData: [],
      }
    }
    default: {
      return state
    }
  }
}

export default reducer
